import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Users, Clock, Globe } from "lucide-react";
import { Button } from "../components/ui/button";
import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
import { doctors } from "./doctors._data";
export default function Home() {
  // const [doctors, setDoctors] = useState([]);

  // useEffect(() => {
  //   const fetchDoctors = async () => {
  //     try {
  //       const response = await axios.get(`${API}/doctors`);
  //       setDoctors(response.data.slice(0, 3));
  //     } catch (error) {
  //       console.error("Error fetching doctors:", error);
  //     }
  //   };
  //   fetchDoctors();
  // }, []);

  const whatsappGroupUrl =
    "https://chat.whatsapp.com/L818Fq4NLh8CidBkbGhhGa?mode=gi_t";
  const whatsappNumber = "918295080493";
  const consultMessage = "Hello! I would like to book a consultation.";

  return (
    <div className="min-h-screen">
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-background via-accent/30 to-background"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h1
                className="text-5xl md:text-6xl font-heading font-bold text-[#2D3436] leading-tight"
                data-testid="hero-title"
              >
                Vision for Better Health Through{" "}
                <span className="text-primary">Ayurveda</span>
              </h1>
              <p className="text-lg md:text-xl text-[#636E72] leading-relaxed">
                Experience the healing power of ancient Ayurvedic wisdom
                combined with modern medical understanding. Holistic care for
                chronic lifestyle disorders and lasting wellness.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(consultMessage)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    className="bg-primary hover:bg-[#3A5233] text-white rounded-full px-8 py-6 text-lg font-medium transition-all shadow-sm hover:shadow-md"
                    data-testid="hero-consult-button"
                  >
                    Consult on WhatsApp
                    <ArrowRight className="ml-2" size={20} />
                  </Button>
                </a>
                <Link to="/doctors">
                  <Button
                    className="bg-primary hover:bg-[#3A5233] text-white rounded-full px-8 py-6 text-lg font-medium transition-all shadow-sm hover:shadow-md"
                    data-testid="hero-consult-button"
                  >
                    View Our Doctors
                    <ArrowRight className="ml-2" size={20} />
                  </Button>
                </Link>
              </div>

              <a
                href={whatsappGroupUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="link"
                  className="text-secondary hover:text-secondary/80 font-medium"
                  data-testid="whatsapp-group-link"
                >
                  Join WhatsApp Consultation Group →
                </Button>
              </a>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1600632517836-99979e3b12d6?crop=entropy&cs=srgb&fm=jpg&q=85"
                  alt="Ayurvedic herbs and treatments"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent"></div>
              </div>
              <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                    <CheckCircle className="text-secondary" size={24} />
                  </div>
                  <div>
                    <p className="font-semibold text-[#2D3436]">
                      Certified Doctors
                    </p>
                    <p className="text-sm text-[#636E72]">
                      Expert Ayurvedic Care
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-heading font-semibold text-[#2D3436] mb-4">
              Why Choose Ayurveda?
            </h2>
            <p className="text-lg text-[#636E72] max-w-3xl mx-auto">
              Ancient Indian medical science focused on root-cause treatment and
              holistic healing
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-accent/30 p-8 rounded-xl text-center hover:bg-accent/50 transition-all duration-300">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Users className="text-primary" size={32} />
              </div>
              <h3 className="text-xl font-heading font-semibold text-[#2D3436] mb-3">
                Holistic Approach
              </h3>
              <p className="text-[#636E72] leading-relaxed">
                Treatment of the whole person - body, mind, and spirit - not
                just symptoms
              </p>
            </div>

            <div className="bg-accent/30 p-8 rounded-xl text-center hover:bg-accent/50 transition-all duration-300">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Clock className="text-secondary" size={32} />
              </div>
              <h3 className="text-xl font-heading font-semibold text-[#2D3436] mb-3">
                Lasting Results
              </h3>
              <p className="text-[#636E72] leading-relaxed">
                Focus on prevention and lifestyle modification for long-term
                health improvement
              </p>
            </div>

            <div className="bg-accent/30 p-8 rounded-xl text-center hover:bg-accent/50 transition-all duration-300">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Globe className="text-primary" size={32} />
              </div>
              <h3 className="text-xl font-heading font-semibold text-[#2D3436] mb-3">
                National & International
              </h3>
              <p className="text-[#636E72] leading-relaxed">
                Online consultations available for patients across India and
                globally
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-heading font-semibold text-[#2D3436] mb-4">
              Our Expert Doctors
            </h2>
            <p className="text-lg text-[#636E72]">
              Certified Ayurvedic physicians with years of experience
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {doctors.map((doctor) => (
              <div
                key={doctor.id}
                className="bg-white rounded-xl overflow-hidden border border-border/50 shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="relative h-64 bg-accent overflow-hidden">
                  {doctor.photo_url ? (
                    <img
                      src={doctor.photo_url}
                      alt={doctor.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10">
                      <div className="w-24 h-24 bg-primary/20 rounded-full flex items-center justify-center">
                        <span className="text-4xl font-heading text-primary">
                          {doctor.name.charAt(0)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-heading font-semibold text-[#2D3436] mb-2">
                    {doctor.name}
                  </h3>
                  <p className="text-sm text-[#636E72] mb-4">
                    {doctor.qualifications}
                  </p>
                  <Link to={`/doctors/${doctor.id}`}>
                    <Button
                      variant="outline"
                      className="w-full border-primary text-primary hover:bg-primary hover:text-white rounded-full"
                    >
                      View Profile
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/doctors">
              <Button
                className="bg-primary hover:bg-[#3A5233] text-white rounded-full px-8 py-3 font-medium"
                data-testid="view-all-doctors-button"
              >
                View All Doctors
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-primary text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold mb-6">
            Ready to Start Your Healing Journey?
          </h2>
          <p className="text-lg mb-6 opacity-90">
            Book a consultation today and experience personalized Ayurvedic care
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold mb-4">Consultation Charges</h3>
            <div className="space-y-2 text-base">
              <p className="font-medium">
                ✨ First Consultation:{" "}
                <span className="text-2xl font-bold">FREE</span>
              </p>
              <p>
                📍 Indian Citizens: <span className="font-semibold">₹200</span>{" "}
                per consultation (after first)
              </p>
              <p>
                🌍 International Patients: Fees discussed during consultation
              </p>
            </div>
          </div>

          <a href={whatsappGroupUrl} target="_blank" rel="noopener noreferrer">
            <Button
              className="bg-white text-primary hover:bg-accent rounded-full px-8 py-6 text-lg font-medium"
              data-testid="cta-consult-button"
            >
              Join WhatsApp Group
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
}
